import React, { useState } from "react";
import styled from "styled-components";
import Modal from "../../Kanban/Modal/Modal";

import CreateNewContact from "./ContractAndAddresesModals/CreateNewContact";
import UploadedImage from "../../UploadedImagedComponent/UploadedImage";
import cameraIcon from "../../../Images/camera.svg";
import { useLanguage } from "../../LangTranslation/LanguageContext";

const ActionButton = styled.button`
  border-radius: 10px;
  background-color: #ff5837;
  color: #ffffff;
  family-font: "Inter";
  border: none;
  // width: 80px;
  min-width: 130px;
  height: 35px;
  margin-right: 20px;
  margin-top: 25px;
`;

// const ButtonsDiv = styled.button`

//   background-color: #fff;
//   width:100%;
//   margin-bottom:20px;

// `;

const ContactsAndAddresses = ({
  name,
  form,
  push,
  replace,
  contactIncommingOptions,
  setContactIncommingOptions,
  disabled,
  ...restProps
}) => {
  const { language, translations } = useLanguage();
  const t = translations[language];
  const { values = {} } = form;
  const contactList = values?.[name] || [];
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedContactData, setSelectedContactData] = useState(null);

  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = (modalStatus = false) => {
    setIsModalOpen(modalStatus);
    setSelectedContactData(null);
  };
  const findContact = (incomingValues) => {
    return contactList.findIndex((contact) => contact.id === incomingValues.id);
  };

  const handleReplace = (index, incomingValues, modalStatus) => {
    replace(index, incomingValues);
    closeModal(modalStatus);
  };
  const handleRemove = (incomingValues) => {
    const existingcontactIndex = findContact(incomingValues);
    if (existingcontactIndex >= 0) {
      handleReplace(existingcontactIndex, {
        ...incomingValues,
        isDeleted: true,
      });
    }
  };
  const handleAddContact = (incomingValues, modalStatus = false) => {
    if (incomingValues.id) {
      const existingcontactIndex = findContact(incomingValues);
      if (existingcontactIndex >= 0) {
        handleReplace(existingcontactIndex, incomingValues, modalStatus);
        return;
      }
    }
    const id = `virtual_${parseInt(Math.random() * 1000)}`;
    push({ ...incomingValues, id });
    closeModal(modalStatus);
  };
  return (
    <div>
      {!disabled && (
        <ActionButton type="button" onClick={openModal}>
          + {t["Add New"]}
        </ActionButton>
      )}

      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <CreateNewContact
          disabled={disabled}
          contactIncommingOptions={contactIncommingOptions}
          setContactIncommingOptions={setContactIncommingOptions}
          handleAddContact={handleAddContact}
          closeModal={closeModal}
          selectedContactData={selectedContactData}
          handleRemove={handleRemove}
        />
      </Modal>

      <div className="row mt-3">
        {contactList
          ?.filter((contact) => contact?.isDeleted === false)
          .map((contact) => (
            <div className="col-4 p-2 ">
              <div
                className="d-flex card-body h-100 align-items-start cursor-pointer"
                style={{
                  borderRadius: "10px",
                  border: "1px solid rgba(0,0,0,.125)",
                }}
                onClick={() => {
                  setSelectedContactData(contact);
                  openModal();
                }}
              >
                <div className="w-25">
                  <UploadedImage src={contact.image_1920 || cameraIcon} />
                </div>
                <div className="d-block ps-5">
                  {contact.name && <div>{contact.name}</div>}
                  {contact.email && <div>{contact.email}</div>}
                  {(contact.zip || contact.city) && (
                    <div>
                      <span>{contact.zip}</span>
                      <span className="ps-2">{contact.city}</span>
                    </div>
                  )}
                  {(contact.country || contact.state) && (
                    <div>
                      <span>{contact?.state?.label}</span>
                      <span className="ps-2">{contact?.country?.label}</span>
                    </div>
                  )}
                  {contact.phone && (
                    <div>
                      {t["Phone"]}:<span className="ps-2">{contact.phone}</span>
                    </div>
                  )}
                  {contact.mobile && (
                    <div>
                      {t[" Mobile"]}:
                      <span className="ps-2">{contact.mobile}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default ContactsAndAddresses;
